import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  children?: ReactNode;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
  children,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`flex flex-col gap-5 md:flex-row md:items-end ${isCenter ? "md:flex-col md:items-center md:text-center" : "md:justify-between"}`}
    >
      <div className={`max-w-2xl ${isCenter ? "text-center" : ""}`}>
        <div className={`flex items-center gap-2 ${isCenter ? "justify-center" : ""}`}>
          <span className="h-px w-7 bg-accent-500"></span>
          <span className="text-[11px] font-medium uppercase tracking-wider2 text-accent-600">{eyebrow}</span>
        </div>
        <h2 className="mt-3 font-heading text-2xl leading-snug text-foreground-950 md:text-[30px]">{title}</h2>
        {description && <p className="mt-3 text-sm leading-relaxed text-foreground-600">{description}</p>}
        {children}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="group inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 bg-background-50 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          {actionLabel}
          <i
            className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1"
            aria-hidden="true"
          ></i>
        </Link>
      )}
    </div>
  );
}